module.exports = __webpack_public_path__ + "static/media/support-icon.9e501fca.svg";